import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessNeighbours } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { UserBulkUploadPage } from "./pages/bulk-upload/UserBulkUploadPage";
import { CreateUserPage } from "./pages/create-or-edit/CreateUserPage";
import { EditUserPage } from "./pages/create-or-edit/EditUserPage";
import { UserDetailsPage } from "./pages/details/UserDetailsPage";
import { UserListPage } from "./pages/list/UserListPage";
import { ResidentEditSelfPage } from "./pages/resident-edit-self/ResidentEditSelfPage";
import { canAccessBulkUploadUsers, canInviteUser } from "./permissions";
import { usersRoutes } from "./routes";

export const usersRoute = [
  {
    path: usersRoutes.list,
    element: (
      <RequireAuth permission={canAccessNeighbours}>
        <UserListPage />
      </RequireAuth>
    ),
  },
  {
    path: usersRoutes.details,
    element: <UserDetailsPage />,
  },
  {
    path: usersRoutes.new,
    element: (
      <RequireAuth permission={canInviteUser}>
        <CreateUserPage />
      </RequireAuth>
    ),
  },
  {
    path: usersRoutes.edit,
    element: (
      <RequireAuth permission={(x) => x.isAdmin}>
        <EditUserPage />
      </RequireAuth>
    ),
  },
  {
    path: usersRoutes.editSelf,
    element: <ResidentEditSelfPage />,
  },
  {
    path: usersRoutes.bulkUpload,
    element: (
      <RequireAuth permission={canAccessBulkUploadUsers}>
        <UserBulkUploadPage />
      </RequireAuth>
    ),
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
